<template>
  <a-modal
    v-model="visible"
    title="操作定时任务"
    :width="720"
    @ok="submit"
    @cancel="close"
    :confirmLoading="loading"
  >
    <a-form :form="form">
      <a-form-item
        label="任务名称"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          v-decorator="[
            'jobName',
            { rules: [{ required: true, message: '请填写任务名称' }] }
          ]"
        >
        </a-input>
      </a-form-item>
      <a-form-item
        label="任务类型"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-select
          v-decorator="[
            'jobType',
            {
              initialValue: 'J',
              rules: [
                {
                  required: true,
                  message: '请选择任务类型'
                }
              ]
            }
          ]"
        >
          <a-select-option value="J">java对象</a-select-option>
          <a-select-option value="S">shell脚本</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item
        label="执行对象"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          v-decorator="[
            'jobObject',
            {
              rules: [
                {
                  required: true,
                  message: '请填写执行对象'
                }
              ]
            }
          ]"
        >
        </a-input>
      </a-form-item>
      <a-form-item
        label="触发时间"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          v-decorator="[
            'cronExpression',
            { rules: [{ required: true, message: '请填写' }] }
          ]"
        >
        </a-input>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { save } from "@/api/system/comScheduleJob";
import pick from "lodash/pick";

export default {
  name: "ComScheduleJobColumnsModal",
  data() {
    return {
      modal: {},
      loading: false,
      visible: false,
      form: this.$form.createForm(this),
      labelCol: { lg: { span: 7 }, sm: { span: 24 } },
      wrapperCol: { lg: { span: 15 }, sm: { span: 24 } }
    };
  },
  methods: {
    show(record) {
      this.visible = true;
      if (record) {
        this.modal = record;
        this.$nextTick(() => {
          this.form.setFieldsValue(
            pick(
              this.modal,
              "jobName",
              "jobType",
              "jobObject",
              "cronExpression"
            )
          );
        });
      }
    },
    submit() {
      this.form.validateFields((err, values) => {
        this.loading = true;
        if (!err) {
          let params = Object.assign(this.modal, values);
          save({ ...params }).then(res => {
            if (res.resultCode === 1) {
              this.$notification.success({ message: res.message });
              this.close();
              this.$emit("ok");
            } else {
              this.$notification.error({ message: res.message });
            }
            this.loading = false;
          });
        } else {
          this.loading = false;
        }
      });
    },
    close() {
      this.title = "新增";
      this.form.resetFields();
      this.visible = false;
    }
  }
};
</script>

<style></style>
